import React from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { Controller } from "react-hook-form";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import {
  EmailAddress,
  MyProfileTitle,
  Save,
} from "../../../../../Utils/Constants";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { useEditProfileForm } from "../../../../../hooks/auth/useEditProfileForm";
import "./MyProfile.css"; // ✅ add this line

export default function MyProfile() {
  const {
    profile,
    loading,
    error,
    control,
    handleSubmit,
    errors,
    isSubmitting,
    onSubmit,
    isDirty,
    isValid,
    validationRules,
  } = useEditProfileForm();

  return (
    <div className="myprofile-container"> {/* ✅ Center wrapper */}
      <Col xl={4} lg={6} md={8} sm={10} xs={12} className="myprofile-col">
        <Card className="myprofile-card">
          <CommonCardHeader titleClass="card-title" title={MyProfileTitle} />
          <CardBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="mb-2">
                <div className="profile-title w-100 mb-3">
                  <div className="d-flex gap-3 align-items-center">
                    {/* <img
                      className="img-70 rounded-circle"
                      alt=""
                      src={dynamicImage(`user/7.jpg`)}
                    /> */}
                    <div className="flex-grow-1">
                      <H3 className="mb-1">
                        {profile?.firstname ?? ""} {profile?.lastname ?? ""}
                      </H3>
                      <P>{profile?.role?.name ?? profile?.role ?? ""}</P>
                    </div>
                  </div>
                </div>

                {loading && (
                  <div className="w-100 my-2 d-flex align-items-center gap-2">
                    <Spinner size="sm" />
                    <P>Loading profile...</P>
                  </div>
                )}

                {error && !loading && <P className="error-text">{error}</P>}

                {!loading && (
                  <>
                    <FormGroup>
                      <Label>{EmailAddress}</Label>
                      <Controller
                        name="email"
                        control={control}
                        rules={validationRules.email}
                        render={({ field }) => (
                          <Input type="email" {...field} disabled />
                        )}
                      />
                      {errors.email && (
                        <span className="error-text">
                          {errors.email.message}
                        </span>
                      )}
                    </FormGroup>

                    <FormGroup>
                      <Label>First Name</Label>
                      <Controller
                        name="firstname"
                        control={control}
                        rules={validationRules.firstname}
                        render={({ field }) => (
                          <Input type="text" {...field} placeholder="First Name" />
                        )}
                      />
                      {errors.firstname && (
                        <span className="error-text">
                          {errors.firstname.message}
                        </span>
                      )}
                    </FormGroup>

                    <FormGroup>
                      <Label>Last Name</Label>
                      <Controller
                        name="lastname"
                        control={control}
                        rules={validationRules.lastname}
                        render={({ field }) => (
                          <Input type="text" {...field} placeholder="Last Name" />
                        )}
                      />
                      {errors.lastname && (
                        <span className="error-text">
                          {errors.lastname.message}
                        </span>
                      )}
                    </FormGroup>
                  </>
                )}

                <div className="form-footer w-100 d-flex align-items-center gap-3">
                  <Btn
                    color="primary"
                    type="submit"
                    block
                    className="w-auto"
                    disabled={!isDirty || !isValid || isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : Save}
                  </Btn>
                </div>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </div>
  );
}
